import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/services/ui-ux-design")({
  component: () => <Outlet />,
});
